const Install = () => (
    <section>
        <div className="anchor-point" id="section-4" />
        <h1>Install locally</h1>
        <hr/><br/>

        <div className="docs__order">
            <p>1. <span className="inline">npm install</span></p>
            <p>2. <span className="inline">npm run dev</span></p>
            <p>3. Open <span className="inline">localhost:4000</span></p>
        </div>
    </section>
)

export default Install